import React, {useRef, useState} from 'react';
import {Button, Dialog, DialogContent, DialogTitle, FormControl, IconButton, Stack, TextField} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import {ISendPassword} from '../../interfaces/fetch/resetPassword';
import instance from '../../instance';
import {getLabelWithAsterisk} from '../../functionts/getLabelWithAsterisk';

interface IForgotPasswordProps {
    isShow: boolean;
    setShow: React.Dispatch<React.SetStateAction<boolean>>;
}

const ForgotPassword = (props: IForgotPasswordProps): React.JSX.Element => {
    const loginInputRef = useRef<HTMLInputElement | null>(null);

    const [inn, setInn] = useState('');
    const [touched, setTouched] = useState(false);
    const [isSuccess, setSuccess] = useState(false);
    const [error, setError] = useState(null);

    const isValid = /^\d{12}$/.test(inn);

    const handlerClose = () => {
        props.setShow(false);
        setInn('');
        setTouched(false);
        setSuccess(false);
        setError(null);
    };

    const handleForForm = () => {
        setTouched(true);

        if (!isValid) return;

        const resetPasswordRequest: ISendPassword = {
            method: 'SendPassword',
            params: {
                inn,
            },
        };

        void fetchResetPasswordRequest(resetPasswordRequest);
    };

    const fetchResetPasswordRequest = async (request: ISendPassword) => {
        try {
            const response = await instance.post('/LK', request);
            if (Number(response.data.error) === 0) {
                setSuccess(true);
            } else {
                setTouched(true);
                if (response.data.error_description) {
                    setError(response.data.error_description);
                }
            }
        } catch {}
    };

    return (
        <Dialog open={props.isShow} disablePortal={true} maxWidth="xs" scroll="body" fullWidth>
            <DialogTitle>Восстановление пароля</DialogTitle>
            <IconButton onClick={handlerClose} className={'dialog-close'}>
                <CloseIcon />
            </IconButton>
            <DialogContent>
                {isSuccess ? (
                    <p>Письмо для подтверждения сброса пароля отправлено на ваш почтовый адрес.</p>
                ) : (
                    <form
                        onSubmit={e => {
                            e.preventDefault();
                            handleForForm();
                        }}
                    >
                        <Stack spacing={2}>
                            <FormControl error={!!error}>
                                <TextField
                                    label={getLabelWithAsterisk('ИИН/БИН', true)}
                                    type="text"
                                    value={inn}
                                    inputRef={loginInputRef}
                                    onChange={e => {
                                        const onlyDigits = e.target.value.replace(/\D/g, '').slice(0, 12);
                                        setError(null);
                                        setInn(onlyDigits);
                                    }}
                                    onBlur={() => setTouched(true)}
                                    onFocus={() => setTouched(false)}
                                    error={(touched && !isValid) || !!error}
                                    helperText={touched && !isValid ? 'Введите корректный ИИН/БИН, 12 цифр' : error ? error : ''}
                                    autoComplete="off"
                                    fullWidth
                                />
                            </FormControl>
                            <Button type="submit" color="primary" disabled={!isValid} fullWidth>
                                Сбросить пароль
                            </Button>
                        </Stack>
                    </form>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default ForgotPassword;
